import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { BaseUrl, excelDownloadUrl } from "../../container/BaseUrl/BaseUrl";
import { Pagination, Skeleton, Stack, Button, Typography } from "@mui/material";
import moment from "moment";
import FileSaver from "file-saver";
import { NavLink } from "react-router-dom";
import { setSelectedMenu } from "../../redux/actions/actions";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import FilterListIcon from "@mui/icons-material/FilterList";
import { DownloadSimple } from "@phosphor-icons/react";
// component imported
// import Filterbutton from "../../components/agent-login-reports/filter-button.component";
// import Loginfilter from "../../components/agent-login-reports/login-filter.component";
import { RiErrorWarningLine } from "react-icons/ri";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";
import {
  FormControls,
  MenuItems,
  Selects,
} from "../../components/Styled-component/TablePagination";
// import theme from "./theme";
const mapStateToProps = (state) => {
  return {
    selectedMenu: state.contactListData.selectedMenu,
  };
};
const AgentLoginLogout = (props) => {
  const selectAgentRef = useRef(null);
  const animatedComponents = makeAnimated();
  //   const [showfilter, setshowfilter] = useState("sidebar_filter");
  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];
  const [agentdata, setAgentdata] = useState([]);
  const [fromdate, setFromdate] = useState(defaultValue);
  const [todate, setTodate] = useState(defaultValue);
  const [agentlist, setAgentlist] = useState([]);
  const [multiPageVal, setMultiPageVal] = React.useState(10);
  const [pagination, setPagination] = useState(0);
  const [agentid, setAgentid] = useState("");
  const [page, setPage] = useState(1);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [loadingAgentreports, setloadingAgentreports] = useState(false);
  const [showfilter, setShowFilter] = useState(false);
  const [agentlistdata, setAgentlistdata] = useState([]);
  const [selectedagent, setSelectedagent] = useState("");

  const [fromDateError, setFromDateError] = useState(false);
  const [toDateError, setToDateError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = () => {
    if (moment(fromdate).isAfter(todate)) {
      setFromDateError(true);
      setToDateError(false);
      setShowFilter(true);
    } else {
      agentReportData();
      setToDateError(false);
      setFromDateError(false);
      handelCloseFilter();
    }
  };

  const agentCallDetailsReportDataAgentList = async () => {
    setApiCallsMade(true);
    await axios
      .post(
        BaseUrlReports + "api/agents",
        {
          tenent_id: localStorage.getItem("TenantId"),
          // tenent_id:"a3dc14bd-fe70-4120-8572-461b0dc866b5"
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        if (res.data) {
          setAgentlistdata(res.data.agents);
        }
      })

      .catch((error) => {
        console.log(error);
      });
  };
  const handelShowFilter = () => {
    setShowFilter(true);
  };
  const handelCloseFilter = () => {
    setShowFilter(false);
  };

  const resetButton = () => {
    selectAgentRef.current.clearValue();
    setTodate("");
    setFromdate("");
    handelCloseFilter();
  };

  const optionsAgent = agentlistdata.map((agent) => ({
    value: agent.agent_id,
    label: agent.agent_name,
  }));

  const basedOnRole = JSON.parse(localStorage.getItem("tokenAgent"));
  useEffect(() => {
    agentListdropdown();
  }, []);
  useEffect(() => {
    agentReportData();
  }, [page, multiPageVal]);

  useEffect(() => {
    agentCallDetailsReportDataAgentList();
  }, []);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      fontSize: "13px",
    }),
  };

  const agentReportData = async () => {
    setLoading(true);
    await axios
      .post(
        BaseUrl + "/users/agentloginlogout",
        {
          from_date: fromdate ? fromdate : defaultValue,
          to_date: todate ? todate : defaultValue,
          offset: page == 1 ? 0 : (page - 1) * multiPageVal,
          limit: multiPageVal,
          agent_id: selectedagent ? selectedagent : "",
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        setLoading(true);
        if (res.data.success == true) {
          setLoading(false);
          console.log("data", res.data.Data);
          setAgentdata(res.data.Data);
          setPagination(res.data.count);
        }
      })
      .catch((error) => {
        setLoading(false);
        setShow(true);
      });
  };
  const agentListdropdown = async () => {
    await axios
      .post(
        BaseUrl + "/users/listagentList",
        {
          type: "AllAgent",
          user_id: basedOnRole.user_id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        console.log(res.data.data);
        setAgentlist(res.data.data);
      })
      .catch((err) => {
        setShow(true);
      });
  };
  const handleChangeSetPage = async (event) => {
    setMultiPageVal(event.target.value);
    setPage(1);
  };
  const handleChange = (event, value) => {
    setPage(value);
  };
  // const DownloadLoginLogoutReports = async () => {
  //   await axios
  //     .post(
  //       BaseUrl + "/users/agentloginlogoutexcel",
  //       {
  //         from_date: fromdate ? fromdate : defaultValue,
  //         to_date: todate ? todate : defaultValue,
  //         offset: page == 1 ? 0 : (page - 1) * 10,
  //         limit: 10,
  //         agent_id: agentid ? agentid : ""
  //       },
  //       {
  //         headers: {
  //           Authorization: "Bearer " + localStorage.getItem("access_token"),
  //           "Content-Type": "application/json",
  //           tenantId: localStorage.getItem("TenantId"),
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       if (res.data.status == true) {
  //         let file = excelDownloadUrl + res.data.message;
  //         FileSaver.saveAs(file);
  //       } else {
  //         toast.warn("No Data Found", {
  //           position: "top-right",
  //           autoClose: 1000,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           draggable: true,
  //           progress: undefined,
  //           theme: "light",
  //         });
  //       }
  //     })
  //     .catch((error) => { });
  // };

  const DownloadLoginLogoutReports = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        BaseUrl + "/users/agentloginlogoutexcel",
        {
          from_date: fromdate ? fromdate : defaultValue,
          to_date: todate ? todate : defaultValue,
          offset: page === 1 ? 0 : (page - 1) * 10,
          limit: 10,
          agent_id: agentid ? agentid : "",
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      );
      setIsLoading(true);
      if (response.data.status === true) {
        setIsLoading(false);
        let downloadUrl = "https://dcc.ntt.inaipi.ae/files";
        let file = excelDownloadUrl + response.data.message;
        window.open(file);

        toast.success("Agent LoginLogout Report Downloaded Successfully", {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        setIsLoading(false);
        toast.warn("No Data Found", {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } catch (error) {
      setIsLoading(false);
      toast.warn("No Data Found", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      // Handle error here
    }
  };

  return (
    <>
      <div
        class={
          showfilter
            ? "offcanvas offcanvas-end show"
            : "offcanvas offcanvas-end"
        }
        tabindex="-1"
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
      >
        <div class="offcanvas-header">
          <h5 class="offcanvas-title" id="offcanvasRightLabel">
            Filter
          </h5>
          <button
            onClick={handelCloseFilter}
            type="button"
            class="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div class="offcanvas-body">
          <div class="mb-3">
            <label for="exampleInputfromdate" class="form-label">
              From Date <small class="text-danger">*</small>
            </label>
            <input
              type="date"
              value={fromdate}
              onChange={(e) => {
                setFromdate(e.target.value);
              }}
              class="form-control form-control-lg"
              id="exampleInputfromdate"
            />
            {fromDateError ? (
              <span className="text-danger fw-500" style={{ fontSize: "10px" }}>
                From Date Should Less Than To Date
              </span>
            ) : (
              ""
            )}
          </div>
          <div class="mb-3">
            <label for="exampleInputtodate" class="form-label">
              To Date <small class="text-danger">*</small>
            </label>
            <input
              value={todate}
              type="date"
              onChange={(e) => {
                setTodate(e.target.value);
              }}
              class="form-control form-control-lg"
              id="exampleInputtodate"
            />
          </div>

          <div class="mb-3">
            <label for="exampleInputfromdate" class="form-label">
              Agent <small class="text-danger">*</small>
            </label>
            {/* <Select
              ref={selectAgentRef}
              closeMenuOnSelect={true}
              components={animatedComponents}
              isMulti
              options={optionsAgent}
              placeholder="Select Agent"
              styles={customStyles}
              onChange={handleSelectAgentChange}
            /> */}
            <select
              class="form-select"
              onChange={(e) => setSelectedagent(e.target.value)}
            >
              <option value="">All Agent</option>
              {agentlist
                .sort((a, b) => a.username.localeCompare(b.username))
                .map((item) => {
                  return (
                    <>
                      <option value={item.id}>{item.username}</option>
                    </>
                  );
                })}
            </select>
          </div>
        </div>

        <div class="offcanvas-sub-btn d-flex justify-content-between mb-1">
          <button
            onClick={handelCloseFilter}
            type="button"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            class="btn btn-secondary btn-sm mx-1 flex-fill"
          >
            Close
          </button>
          <button
            onClick={resetButton}
            type="button"
            class="btn btn-sm btn-warning mx-1  flex-fill"
          >
            Reset
          </button>
          <button
            onClick={() => {
              setPage(1);
              handleSubmit();
            }}
            type="button"
            class=" mx-1 btn-sm btn btn-primary flex-fill"
          >
            Submit
          </button>
        </div>
      </div>

      <div className="sessiontable" style={{ overflow: "hidden" }}>
        <header className="card p-2">
          <div className="conatiner-fluid">
            <nav
              className="navbar "
              style={{ paddingTop: "0px", paddingBottom: "0px" }}
            >
              <div className="container-fluid p-0">
                <div className="hed_left d-flex fw-bold">
                  Agent LoginLogout Report
                </div>
                <div className="hed_right d-flex">
                  <Stack direction={"row"} alignItems={"center"}>
                    {/* <ThemeProvider theme={theme}> */}
                    <Button
                      sx={{ marginRight: "2px" }}
                      size="small"
                      variant="contained"
                      endIcon={<DownloadSimple size={18} weight="bold" />}
                      onClick={DownloadLoginLogoutReports}
                      disabled={isLoading}
                    >
                      {isLoading ? "Downloading..." : "Download Report"}
                    </Button>

                    <Button
                      sx={{ marginRight: "2px" }}
                      onClick={handelShowFilter}
                      type="button"
                      variant="contained"
                      size="small"
                    >
                      <FilterListIcon className="me-1" />
                      Filters
                    </Button>

                    {/* </ThemeProvider> */}

                    {/* <Filterbutton setshowfilter={setshowfilter} /> */}
                  </Stack>
                </div>
              </div>
            </nav>
          </div>
        </header>
        <div className="container-fluid" style={{ paddingLeft: "1px" }}>
          <div className="container-fluid p-2">
            <div className="card fixed-table-card vh-79 ">
              <div
                className="card-body agentContactbody"
                style={{
                  width: "100%",
                  whiteSpace: "nowrap",
                  maxHeight: "100vh",
                  overflowX: "scroll",
                  scrollbarWidth: "thin",
                  scrollbarColor: "#888 transparent",
                }}
              >
                <div
                  className="table-responsive vhm-68"
                  style={{ height: "100vh", overflowY: "auto" }}
                >
                  <table className="table table-sm  table-hover align-middle table-fixeded">
                    <thead>
                      <tr>
                        <th scope="col">Agent Name</th>
                        <th scope="col-2" style={{ textAlign: "center" }}>
                          Reports
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {loadingAgentreports ? (
                        [...Array(8)].map((_, rowIndex) => (
                          <tr key={rowIndex}>
                            {[...Array(10)].map((_, colIndex) => (
                              <td key={colIndex}>
                                <Skeleton
                                  variant="text"
                                  width={90}
                                  height={30}
                                />
                              </td>
                            ))}
                          </tr>
                        ))
                      ) : agentdata.length > 0 ? (
                        agentdata.map((rowData, rowIndex) => {
                          return (
                            <tr key={rowData._id}>
                              <td>{rowData.users.username}</td>
                              <td>
                                <table className="table table-sm  table-hover align-middle table-fixeded">
                                  <thead>
                                    <tr>
                                      <th scope="col">Date </th>
                                      <th scope="col">LogIn</th>
                                      <th scope="col">LogOut </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {rowData.paired_events.map(
                                      (item, rowIndex) => {
                                        return (
                                          <tr key={item._id}>
                                            <td>
                                              {item.login_event.created_at
                                                ? moment(
                                                    item.login_event.created_at
                                                  ).format("ll")
                                                : "--"}
                                            </td>
                                            <td>
                                              {item.login_event.created_at
                                                ? moment(
                                                    item.login_event.created_at
                                                  ).format("hh:mm:ss A")
                                                : "--"}
                                            </td>
                                            <td>
                                              {item.logout_event
                                                ? moment(
                                                    item.logout_event.event
                                                      .created_at
                                                  ).format("hh:mm:ss A")
                                                : "--"}
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )}
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <div
                          className="text-muted"
                          style={{
                            flexDirection: "column",
                            marginTop: "20%",
                            display: "flex",
                            position: "absolute",
                            left: "45%",
                            bottom: "40%",
                          }}
                        >
                          <span className="mx-auto">
                            <RiErrorWarningLine size={30} />
                          </span>
                          <span className="mx-auto">
                            <h5
                              className="text-muted mt-2 fw-bold"
                              style={{ fontSize: "13px" }}
                            >
                              No Data Found
                            </h5>
                          </span>
                        </div>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="card-footer rounded-0 d-flex justify-content-between">
                <div>
                  {`Showing ${Math.min(
                    (page - 1) * multiPageVal + 1,
                    isNaN(pagination) ? 0 : pagination
                  )} to ${Math.min(
                    page * multiPageVal,
                    isNaN(pagination) ? 0 : pagination
                  )} of ${isNaN(pagination) ? 0 : pagination} entries`}
                </div>
                <div className="d-flex">
                  <Typography
                    className="mt-1"
                    sx={{ textTransform: "capitalize", fontSize: "12px" }}
                  >
                    Set page
                  </Typography>
                  <FormControls
                    className="ms-1"
                    size="small"
                    sx={{ textTransform: "capitalize", fontSize: "12px" }}
                  >
                    <Selects
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      label="multiPageVal"
                      value={multiPageVal}
                      onChange={handleChangeSetPage}
                    >
                      <MenuItems value={10}>10</MenuItems>
                      <MenuItems value={20}>20</MenuItems>
                      <MenuItems value={50}>50</MenuItems>
                      <MenuItems value={100}>100</MenuItems>
                      <MenuItems value={500}>500</MenuItems>
                    </Selects>
                  </FormControls>
                </div>
                <Pagination
                  count={Math.ceil(pagination / multiPageVal)}
                  page={page}
                  color="primary"
                  size="small"
                  style={{ float: "right" }}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(mapStateToProps, {
  setSelectedMenu,
})(AgentLoginLogout);
